import React from "react";

const Footer = () => {
  return (
    <footer>
      <nav>
        <ul>
          <li>
            <a href="tel: +1-801-391-8872" aria-hidden="true">
              (801) 391-8872
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="mailto:jmadams41resume@gmail.com"
              rel="noreferrer"
            >
              jmadams41resume@gmail.com
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://github.com/BlinkingHeimdall"
              rel="noreferrer"
            >
              GitHub
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://linkedin.com/in/jason-adams-blinkingheimdall"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
